export const SCHEDULING_HOLD_EXPIRATION_MILLISECONDS = 10 * 60 * 1000;
